import { createContext, useContext, type ReactNode } from "react";

import type { ProjectArea } from "@/lib/projectSource";

/**
 * As áreas que a origem do projeto não tem, para os blocos do Diagnóstico (#1784).
 *
 * Vem do projeto (`unavailable_areas`, decidido no backend). Sem provedor, nenhuma área falta:
 * os testes de cada card montam o card sozinho, e o projeto SAP, que é quase todo projeto de
 * hoje, mostra tudo.
 */
const ProjectAreasContext = createContext<readonly ProjectArea[]>([]);

export function ProjectAreasProvider({
  unavailable,
  children,
}: {
  unavailable: readonly ProjectArea[] | undefined;
  children: ReactNode;
}) {
  return (
    <ProjectAreasContext.Provider value={unavailable ?? []}>{children}</ProjectAreasContext.Provider>
  );
}

export function useAreaAvailable(area: ProjectArea): boolean {
  return !useContext(ProjectAreasContext).includes(area);
}

/** Mostra o bloco só se a origem do projeto tem a área (modelo de domínio, P6). */
export function AreaGate({ area, children }: { area: ProjectArea; children: ReactNode }) {
  return useAreaAvailable(area) ? <>{children}</> : null;
}
